module.exports = __webpack_public_path__ + "static/media/question.965071b5.svg";